import { useState } from 'react'
import { brandLogoPath } from '../domain/brandLogo'

/**
 * The make's logo beside the report's heading.
 *
 * The `alt` is empty because the heading beside it already names the make. A text alternative
 * would make a screen reader say "Peugeot" twice in a row.
 *
 * A file that fails to load removes the element rather than leaving a broken-image icon. On the
 * deployed site a missing file still answers 200, because the 404 override serves the app shell;
 * that HTML fails to decode as an image, so `onError` fires all the same.
 */
export function BrandLogo({ brand, vehicleKind }: { brand?: string; vehicleKind?: string }) {
  const [failedSrc, setFailedSrc] = useState<string>()
  const src = brandLogoPath(brand, vehicleKind)
  if (!src || src === failedSrc) return null

  return (
    <img
      className="brand-logo"
      src={src}
      alt=""
      width={56}
      height={40}
      decoding="async"
      onError={() => setFailedSrc(src)}
    />
  )
}
